// 
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import { useContext, useEffect, useRef, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Api from '../contexts/Api';
import Cookies from 'universal-cookie';
import styled, { css } from 'styled-components';
import { Context } from '../App';
import { getTranslate } from '../contexts/Utils';

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const Navigation = ({ lang }) => {
  const { theme, setTheme } = useContext(Context);
  const cookies = new Cookies();
  const user = cookies.get('nudge_user');
  const role = user.role;
  const menuOpen = JSON.parse(localStorage.getItem('nudge_menu')) || false;
  const menuOpenRef = useRef(menuOpen);
  const navRef = useRef();
  const [mobileOpen, setMobileOpen] = useState(false);

  // 
  // ─── TOGGLE MENU IF TRUE IN LOCALSTORAGE ───────────────────────────────────────
  //
  useEffect(() => {
    if (menuOpen) {
      navRef.current.classList.toggle('active');
      document.querySelector('.container').classList.toggle('expanded-menu');
    }

    // add transition after render to prevent wrap transition on load
    setTimeout(() => {
      navRef.current.style.transition = '.3s';
      document.querySelector('#expand').style.transition = '.3s';
      document.querySelector('#logo-link').style.transition = '.3s';
      document.querySelector('.container').style.transition = '.3s';
    }, 100);
  }, [menuOpen])

  // 
  // ─── LOGOUT USER ───────────────────────────────────────
  //
  const Logout = async () => {
    const params = { endpoint: '/auth/logout' }
    const logoutUser = await Api(params)

    if (logoutUser && logoutUser.success) {
      cookies.remove('nudge_user')
      return window.location = "/connexion";
    }
  }

  // 
  // ─── SWITCH THEME ───────────────────────────────────────
  //
  const handleThemeChange = () => {
    setTheme((state) => {
      const newTheme = state === 'light' ? 'dark' : 'light';
      localStorage.setItem('nudge_theme', newTheme);
      return newTheme;
    });
  }

  // 
  // ─── HANDLE EXPAND NAVBAR ───────────────────────────────────────
  //
  const handleExpandNav = () => {
    localStorage.setItem('nudge_menu', !menuOpenRef.current);
    menuOpenRef.current = !menuOpenRef.current;
    navRef.current.classList.toggle('active');
    document.querySelector('.container').classList.toggle('expanded-menu');
  }

  // 
  // ─── NAVLINKS ───────────────────────────────────────
  //
  const NavLinks = () => <>
    <S.NavLinks>
      <S.NavLink activeclassname='active' end to='/' height={23}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M570.6 244C577.2 249.8 577.8 259.1 571.1 266.6C566.2 273.2 556 273.8 549.4 267.1L512 234.1V432C512 476.2 476.2 512 432 512H144C99.82 512 64 476.2 64 432V234.1L26.59 267.1C19.96 273.8 9.849 273.2 4.003 266.6C-1.844 259.1-1.212 249.8 5.414 244L277.4 4.002C283.5-1.334 292.5-1.334 298.6 4.002L570.6 244zM144 480H208V320C208 302.3 222.3 288 240 288H336C353.7 288 368 302.3 368 320V480H432C458.5 480 480 458.5 480 432V206.7L288 37.34L96 206.7V432C96 458.5 117.5 480 144 480zM240 480H336V320H240V480z" /></svg>
        <span>{getTranslate('home', lang)}</span>
      </S.NavLink>
      {!user.deleted && <>
        <S.NavLink end to='/missions'>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 80C0 53.49 21.49 32 48 32H144C170.5 32 192 53.49 192 80V176C192 202.5 170.5 224 144 224H48C21.49 224 0 202.5 0 176V80zM32 80V176C32 184.8 39.16 192 48 192H144C152.8 192 160 184.8 160 176V80C160 71.16 152.8 64 144 64H48C39.16 64 32 71.16 32 80zM0 336C0 309.5 21.49 288 48 288H144C170.5 288 192 309.5 192 336V432C192 458.5 170.5 480 144 480H48C21.49 480 0 458.5 0 432V336zM32 336V432C32 440.8 39.16 448 48 448H144C152.8 448 160 440.8 160 432V336C160 327.2 152.8 320 144 320H48C39.16 320 32 327.2 32 336zM400 32C426.5 32 448 53.49 448 80V176C448 202.5 426.5 224 400 224H304C277.5 224 256 202.5 256 176V80C256 53.49 277.5 32 304 32H400zM400 64H304C295.2 64 288 71.16 288 80V176C288 184.8 295.2 192 304 192H400C408.8 192 416 184.8 416 176V80C416 71.16 408.8 64 400 64zM256 336C256 309.5 277.5 288 304 288H400C426.5 288 448 309.5 448 336V432C448 458.5 426.5 480 400 480H304C277.5 480 256 458.5 256 432V336zM288 336V432C288 440.8 295.2 448 304 448H400C408.8 448 416 440.8 416 432V336C416 327.2 408.8 320 400 320H304C295.2 320 288 327.2 288 336z" /></svg>
          <span>{getTranslate('ongoing_missions', lang)}</span>
        </S.NavLink>
        <S.NavLink to='/missions/historique'>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C172.2 512 97.87 471.8 51.19 409.6C45.88 402.5 47.31 392.5 54.37 387.2C61.44 381.9 71.47 383.3 76.78 390.4C117.7 444.8 182.7 480 256 480C379.7 480 480 379.7 480 256C480 132.3 379.7 32 256 32C166.7 32 89.51 84.3 53.55 160H144C152.8 160 160 167.2 160 176C160 184.8 152.8 192 144 192H16C7.164 192 0 184.8 0 176V48C0 39.16 7.164 32 16 32C24.84 32 32 39.16 32 48V131.1C75.66 53.29 159.6 0 256 0zM256 128C264.8 128 272 135.2 272 144V249.4L347.3 324.7C353.6 330.9 353.6 341.1 347.3 347.3C341.1 353.6 330.9 353.6 324.7 347.3L244.7 267.3C241.7 264.3 239.1 260.2 239.1 256V144C239.1 135.2 247.2 128 255.1 128H256z" /></svg>
          <span>{getTranslate('history', lang)}</span>
        </S.NavLink>
        <S.NavLink to='/factures'>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M365.3 125.3l-106.5-106.5C246.7 6.742 230.5 0 213.5 0H64C28.65 0 0 28.65 0 64l.0065 384c0 35.35 28.65 64 64 64H320c35.35 0 64-28.65 64-64V170.5C384 153.5 377.3 137.3 365.3 125.3zM224 34.08c4.477 1.566 8.666 3.846 12.12 7.299l106.5 106.5C346.1 151.3 348.4 155.5 349.9 160H240C231.2 160 224 152.8 224 144V34.08zM352 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h128v112C192 170.5 213.5 192 240 192H352V448zM80 96h64C152.8 96 160 88.84 160 80S152.8 64 144 64h-64C71.16 64 64 71.16 64 80S71.16 96 80 96zM160 144C160 135.2 152.8 128 144 128h-64C71.16 128 64 135.2 64 144S71.16 160 80 160h64C152.8 160 160 152.8 160 144zM202 288.9c6.766 .9375 14.2 2.984 21.28 5.156c8.5 2.641 17.41-2.156 19.98-10.61c2.594-8.438-2.156-17.39-10.61-19.98c-10.03-3.078-17.96-4.947-24.99-6.008C207.8 256.1 208 256.5 208 256V240c0-8.844-7.133-16-15.98-16S176 231.2 176 240V256c0 .3008 .1543 .5488 .1699 .8457C150.6 260.1 132.9 273.3 128.9 294.1c-7.766 39.97 33.06 50.64 52.67 55.77l6.5 1.656c32.25 8.219 37.17 12.28 35.61 20.34c-1.844 9.453-19.78 14.34-41.81 11.22c-8.578-1.141-18.95-4.469-28.09-7.391l-4.969-1.594c-8.422-2.578-17.41 2.016-20.08 10.45c-2.656 8.438 2.031 17.42 10.45 20.08L144 406.1c10.05 3.221 21.38 6.756 32.3 8.359C176.3 415 176 415.5 176 416v16c0 8.844 7.18 16 16.02 16S208 440.8 208 432V416c0-.5078-.2422-.9375-.2891-1.434c25.42-3.33 43.36-15.98 47.38-36.63c7.859-40.41-32.45-50.67-59.13-57.45L189.7 318.9c-31.39-8.203-30.41-13.3-29.36-18.7C162.1 290.7 180.1 285.9 202 288.9z" /></svg>          <span>{getTranslate('my_bills', lang)}</span>
        </S.NavLink>
      </>}
      {role === 3 && !user.deleted && <>
        <S.NavLink to='/utilisateurs' height={20}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M274.7 304H173.3c-95.73 0-173.3 77.6-173.3 173.3C0 496.5 15.52 512 34.66 512H413.3C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304zM413.3 480H34.66C33.2 480 32 478.8 32 477.3C32 399.4 95.4 336 173.3 336H274.7C352.6 336 416 399.4 416 477.3C416 478.8 414.8 480 413.3 480zM224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM224 32c52.94 0 96 43.06 96 96c0 52.93-43.06 96-96 96S128 180.9 128 128C128 75.06 171.1 32 224 32zM375.1 241C392.9 250.8 412.3 256 432 256C493.8 256 544 205.8 544 144S493.8 32 432 32c-12.83 0-25.39 2.156-37.34 6.391c-8.328 2.953-12.69 12.09-9.734 20.42c2.953 8.344 12.12 12.66 20.42 9.734C413.9 65.53 422.8 64 432 64C476.1 64 512 99.89 512 144S476.1 224 432 224c-14.08 0-27.91-3.703-39.98-10.69c-7.656-4.453-17.44-1.828-21.86 5.828C365.7 226.8 368.3 236.6 375.1 241zM490.7 320H448c-8.844 0-16 7.156-16 16S439.2 352 448 352h42.67C555.4 352 608 404.6 608 469.3C608 475.2 603.2 480 597.3 480H496c-8.844 0-16 7.156-16 16s7.156 16 16 16h101.3C620.9 512 640 492.9 640 469.3C640 386.1 573 320 490.7 320z" /></svg>
          <span>{getTranslate('users', lang)}</span>
        </S.NavLink>
        {/* <S.NavLink to='/analytics' height={21}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M240 32C266.5 32 288 53.49 288 80V432C288 458.5 266.5 480 240 480H208C181.5 480 160 458.5 160 432V80C160 53.49 181.5 32 208 32H240zM240 64H208C199.2 64 192 71.16 192 80V432C192 440.8 199.2 448 208 448H240C248.8 448 256 440.8 256 432V80C256 71.16 248.8 64 240 64zM80 224C106.5 224 128 245.5 128 272V432C128 458.5 106.5 480 80 480H48C21.49 480 0 458.5 0 432V272C0 245.5 21.49 224 48 224H80zM80 256H48C39.16 256 32 263.2 32 272V432C32 440.8 39.16 448 48 448H80C88.84 448 96 440.8 96 432V272C96 263.2 88.84 256 80 256zM320 144C320 117.5 341.5 96 368 96H400C426.5 96 448 117.5 448 144V432C448 458.5 426.5 480 400 480H368C341.5 480 320 458.5 320 432V144zM352 144V432C352 440.8 359.2 448 368 448H400C408.8 448 416 440.8 416 432V144C416 135.2 408.8 128 400 128H368C359.2 128 352 135.2 352 144z" /></svg>
          <span>Analytics</span>
        </S.NavLink> */}
      </>
      }
    </S.NavLinks>
    <S.NavLinks border={mobileOpen} className="bottom">
      {!user.deleted && <>
        <S.NavLink to='/mon-compte' height={23}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-47.24 0-91.04-14.78-127.2-39.84C132.9 390.9 173.8 352 224 352h64c50.25 0 91.14 38.94 95.21 88.16C347 465.2 303.2 480 256 480zM411.7 416.7C397.6 361.3 347.7 320 288 320H224c-59.73 0-109.6 41.3-123.7 96.72C58.27 375.1 32 319 32 256c0-123.5 100.5-224 224-224s224 100.5 224 224C480 319 453.7 375.1 411.7 416.7zM256 128C211.8 128 176 163.8 176 208C176 252.2 211.8 288 256 288s80-35.82 80-80C336 163.8 300.2 128 256 128zM256 256C229.5 256 208 234.5 208 208S229.5 160 256 160s48 21.53 48 48S282.5 256 256 256z" /></svg>
          <span>{getTranslate('my_account', lang)}</span>
        </S.NavLink >
        {role === 3 &&
          <S.NavLink to='/parametres' height={21}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M168 255.1C168 207.4 207.4 167.1 256 167.1C304.6 167.1 344 207.4 344 255.1C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 255.1zM256 199.1C225.1 199.1 200 225.1 200 255.1C200 286.9 225.1 311.1 256 311.1C286.9 311.1 312 286.9 312 255.1C312 225.1 286.9 199.1 256 199.1zM65.67 230.6L25.34 193.8C14.22 183.7 11.66 167.2 19.18 154.2L49.42 101.8C56.94 88.78 72.51 82.75 86.84 87.32L138.8 103.9C152.2 93.56 167 84.96 182.8 78.43L194.5 25.16C197.7 10.47 210.7 0 225.8 0H286.2C301.3 0 314.3 10.47 317.5 25.16L329.2 78.43C344.1 84.96 359.8 93.56 373.2 103.9L425.2 87.32C439.5 82.75 455.1 88.78 462.6 101.8L492.8 154.2C500.3 167.2 497.8 183.7 486.7 193.8L446.3 230.6C447.4 238.9 448 247.4 448 255.1C448 264.6 447.4 273.1 446.3 281.4L486.7 318.2C497.8 328.3 500.3 344.8 492.8 357.8L462.6 410.2C455.1 423.2 439.5 429.2 425.2 424.7L373.2 408.1C359.8 418.4 344.1 427 329.2 433.6L317.5 486.8C314.3 501.5 301.3 512 286.2 512H225.8C210.7 512 197.7 501.5 194.5 486.8L182.8 433.6C167 427 152.2 418.4 138.8 408.1L86.84 424.7C72.51 429.2 56.94 423.2 49.42 410.2L19.18 357.8C11.66 344.8 14.22 328.3 25.34 318.2L65.67 281.4C64.57 273.1 64 264.6 64 255.1C64 247.4 64.57 238.9 65.67 230.6V230.6zM158.4 129.2L145.1 139.5L77.13 117.8L46.89 170.2L99.58 218.2L97.39 234.8C96.47 241.7 96 248.8 96 255.1C96 263.2 96.47 270.3 97.39 277.2L99.58 293.8L46.89 341.8L77.13 394.2L145.1 372.5L158.4 382.8C169.5 391.4 181.9 398.6 195 403.1L210.5 410.4L225.8 480H286.2L301.5 410.4L316.1 403.1C330.1 398.6 342.5 391.4 353.6 382.8L366.9 372.5L434.9 394.2L465.1 341.8L412.4 293.8L414.6 277.2C415.5 270.3 416 263.2 416 256C416 248.8 415.5 241.7 414.6 234.8L412.4 218.2L465.1 170.2L434.9 117.8L366.9 139.5L353.6 129.2C342.5 120.6 330.1 113.4 316.1 108L301.5 101.6L286.2 32H225.8L210.5 101.6L195 108C181.9 113.4 169.5 120.6 158.4 129.2H158.4z" /></svg>
            <span>{getTranslate('settings', lang)}</span>
          </S.NavLink>}
        <S.Button onClick={handleThemeChange} height={22}>
          {theme === 'light' ?
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M428.3 367.5c-5.609-9.312-16.08-13.91-26.75-11.97c-42.39 8.188-85.83-2.938-119.2-30.5C248.4 297 228.9 255.5 228.9 211.3c0-52.75 28.2-101.8 73.59-127.8c9.453-5.406 14.38-15.88 12.55-26.66c-1.812-10.75-9.891-19-20.61-21C283.1 33.66 265.3 32 253.9 32C131.5 32 32 132.5 32 256s99.55 224 221.9 224c67.19 0 130-30.25 172.4-83C433.1 388.4 433.9 376.9 428.3 367.5zM253.9 448C149.2 448 64 361.9 64 256s85.19-192 189.9-192c4.891 0 11.53 .4062 18.09 1.031C225.3 98.34 196.9 152.9 196.9 211.3c0 53.84 23.7 104.3 65.05 138.5c36.25 29.94 82.17 43.88 128.5 39.69C354.8 426.8 305.8 448 253.9 448z" /></svg>
            : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M240 16C240 7.164 247.2 0 256 0C264.8 0 272 7.164 272 16V104C272 112.8 264.8 120 256 120C247.2 120 240 112.8 240 104V16zM160 256C160 202.1 202.1 160 256 160C309 160 352 202.1 352 256C352 309 309 352 256 352C202.1 352 160 309 160 256zM256 320C291.3 320 320 291.3 320 256C320 220.7 291.3 192 256 192C220.7 192 192 220.7 192 256C192 291.3 220.7 320 256 320zM256 512C247.2 512 240 504.8 240 496V416C240 407.2 247.2 400 256 400C264.8 400 272 407.2 272 416V496C272 504.8 264.8 512 256 512zM0 256C0 247.2 7.164 240 16 240H96C104.8 240 112 247.2 112 256C112 264.8 104.8 272 96 272H16C7.164 272 0 264.8 0 256zM496 240C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H408C399.2 272 392 264.8 392 256C392 247.2 399.2 240 408 240H496zM74.98 437C68.73 430.8 68.73 420.6 74.98 414.4L131.5 357.8C137.8 351.6 147.9 351.6 154.2 357.8C160.4 364.1 160.4 374.2 154.2 380.5L97.61 437C91.36 443.3 81.23 443.3 74.98 437V437zM414.4 74.98C420.6 68.73 430.8 68.73 437 74.98C443.3 81.23 443.3 91.36 437 97.61L374.8 159.8C368.5 166.1 358.4 166.1 352.2 159.8C345.9 153.6 345.9 143.5 352.2 137.2L414.4 74.98zM74.98 74.98C81.23 68.73 91.36 68.73 97.61 74.98L154.2 131.5C160.4 137.8 160.4 147.9 154.2 154.2C147.9 160.4 137.8 160.4 131.5 154.2L74.98 97.61C68.73 91.36 68.73 81.23 74.98 74.98V74.98zM437 414.4C443.3 420.6 443.3 430.8 437 437C430.8 443.3 420.6 443.3 414.4 437L352.2 374.8C345.9 368.5 345.9 358.4 352.2 352.2C358.4 345.9 368.5 345.9 374.8 352.2L437 414.4z" /></svg>
          }
          <span>{getTranslate('theme', lang)}</span>
        </S.Button>
      </>}
      <S.Button onClick={Logout}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M507.3 244.7l-144-144c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L457.4 240H176C167.2 240 160 247.2 160 256s7.156 16 16 16h281.4l-116.7 116.7c-6.25 6.25-6.25 16.38 0 22.62s16.38 6.25 22.62 0l144-144C510.4 264.2 512 260.1 512 256S510.4 247.8 507.3 244.7zM176 448h-96C53.53 448 32 426.5 32 400v-288C32 85.53 53.53 64 80 64h96C184.8 64 192 56.84 192 48S184.8 32 176 32h-96C35.88 32 0 67.88 0 112v288C0 444.1 35.88 480 80 480h96C184.8 480 192 472.8 192 464S184.8 448 176 448z" /></svg>
        <span>{getTranslate('logout', lang)}</span>
      </S.Button>
    </S.NavLinks>
    <S.Footer className='footer'>
      <div>
        <S.NavLink to='/cgu'>CGU</S.NavLink>
        <S.NavLink to='/cgv'>CGV</S.NavLink>
      </div>
      <div>
        <S.NavLink to='/mentions-legales'>Mentions Légales</S.NavLink>
        <S.NavLink className="website" as='a' href="https://nudgetech.fr/" target="_blank" rel="noopener noreferrer">Site internet</S.NavLink>
      </div>
    </S.Footer>
  </>

  // 
  // ─── RESPONSIVE ───────────────────────────────────────
  //
  const MobileNavigation = () => <S.MobileContent active={mobileOpen}>
    <NavLinks />
  </S.MobileContent>

  const toggleMobileNav = () => {
    document.body.style.overflow = mobileOpen ? 'unset' : 'hidden';
    setMobileOpen(!mobileOpen);
  }

  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return <>
    <S.Container className='active' ref={navRef}>
      <svg id='expand' onClick={handleExpandNav} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M219.9 266.7L75.89 426.7c-5.906 6.562-16.03 7.094-22.59 1.188c-6.918-6.271-6.783-16.39-1.188-22.62L186.5 256L52.11 106.7C46.23 100.1 46.75 90.04 53.29 84.1C59.86 78.2 69.98 78.73 75.89 85.29l144 159.1C225.4 251.4 225.4 260.6 219.9 266.7z" /></svg>
      <Link to='/' id="logo-link">
        <svg id='logo' xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
          <path data-name="Icône logo Blanc" d="M1309.634,1526.167c5.718,3.83,12.676,3.452,18.393.324a22.381,22.381,0,0,0,10.68-13.484,21.564,21.564,0,0,1-2.859,5.663,20.566,20.566,0,0,1-3.884,4.207c-.431.323-.809.594-1.24.917-.432.269-.809.539-1.241.809a16.336,16.336,0,0,1-9.169,2.373,11.7,11.7,0,0,1-6.311-2.049l-.324-.162a6.878,6.878,0,0,1-.917-.862,14.342,14.342,0,0,0,8.522.808,16.218,16.218,0,0,0,9.385-5.663,19.624,19.624,0,0,0,4.477-9.924,22.818,22.818,0,0,0-2.589-14.24c3.129,6.311,3.4,13.97-.863,20.226-2.319,3.344-5.771,5.879-9.816,5.771a14.177,14.177,0,0,0,7.012-6.041,16.653,16.653,0,0,0,2.265-7.443,19.207,19.207,0,0,0-3.344-11.974,22.138,22.138,0,0,0-12.46-9.008c8.253,2.643,15.1,10.787,13.808,19.9a10.378,10.378,0,0,1-2.967,6.04,14.436,14.436,0,0,0,.486-9.978,17.75,17.75,0,0,0-8.145-9.978,21.963,21.963,0,0,0-21.359.162,21.822,21.822,0,0,1,6.9-2.1,22.774,22.774,0,0,1,3.291-.162,20.446,20.446,0,0,1,5.933,1.025,18.517,18.517,0,0,1,3.614,1.726,14.265,14.265,0,0,1,4.909,5.071,13.421,13.421,0,0,1,.916,2,7.767,7.767,0,0,1,.485,3.129,14.161,14.161,0,0,0-5.447-6.634,16.667,16.667,0,0,0-12.351-2.427,19.833,19.833,0,0,0-8.469,3.667,23.227,23.227,0,0,0-8.252,11.92c2.211-6.472,7.281-11.974,14.293-13.592,4.1-.917,8.684-.323,11.651,2.7a14.6,14.6,0,0,0-10.68-.216,16.864,16.864,0,0,0-4.1,2.211,19.043,19.043,0,0,0-7.714,13.754,22.682,22.682,0,0,0,2.751,13.269c-3.29-6.472-3.4-14.563,1.187-20.712,2.319-3.074,5.609-5.34,9.438-5.286a13.9,13.9,0,0,0-5.286,3.722,16.6,16.6,0,0,0-3.56,14.94,20.6,20.6,0,0,0,6.9,11.273,24.888,24.888,0,0,0,8.468,4.585,21.749,21.749,0,0,1-11.165-8.63c-3.02-4.746-4.045-10.572-1.133-15.533a3.686,3.686,0,0,0,.378-.594,5.951,5.951,0,0,1,1.078-1.24c-.216.593-.485,1.186-.647,1.78-.108.432-.162.809-.27,1.24-1.348,7.335,3.075,14.185,9.439,17.367a22.036,22.036,0,0,0,20.5-.593,22.977,22.977,0,0,1-6.85,2.1,22.139,22.139,0,0,1-5.663,0,18.733,18.733,0,0,1-6.1-1.942,15.085,15.085,0,0,1-4.962-4.1c-.216-.27-.378-.539-.593-.809a9.953,9.953,0,0,1-1.888-5.933A14.43,14.43,0,0,0,1309.634,1526.167Zm-5.755-15.4a9.129,9.129,0,0,1,3.244-4.687,7.8,7.8,0,0,1,3.329-1.442,6.556,6.556,0,0,1,4.856.955,5.571,5.571,0,0,1,2.142,2.608,3.058,3.058,0,0,0-.191-1.23,5.358,5.358,0,0,0-.36-.785,5.615,5.615,0,0,0-1.93-1.993,7.284,7.284,0,0,0-1.42-.678,8.081,8.081,0,0,0-2.332-.4,9.02,9.02,0,0,0-1.294.064,8.585,8.585,0,0,0-2.714.827,8.634,8.634,0,0,1,8.4-.063,6.975,6.975,0,0,1,3.2,3.923,5.673,5.673,0,0,1-.191,3.923,4.082,4.082,0,0,0,1.166-2.375c.509-3.583-2.184-6.786-5.428-7.825a8.706,8.706,0,0,1,4.9,3.541,7.546,7.546,0,0,1,1.314,4.708,6.543,6.543,0,0,1-.89,2.926,5.57,5.57,0,0,1-2.757,2.374,4.693,4.693,0,0,0,3.859-2.268,7.815,7.815,0,0,0,.339-7.952,8.969,8.969,0,0,1,1.018,5.6,7.714,7.714,0,0,1-1.76,3.9,6.377,6.377,0,0,1-3.689,2.226,5.634,5.634,0,0,1-3.35-.318,2.749,2.749,0,0,0,.361.34l.127.063a4.6,4.6,0,0,0,2.481.805,6.423,6.423,0,0,0,3.6-.933c.169-.106.318-.212.487-.318.169-.128.319-.234.488-.361a8.1,8.1,0,0,0,1.527-1.654,8.439,8.439,0,0,0,1.124-2.227,8.793,8.793,0,0,1-4.2,5.3,6.887,6.887,0,0,1-7.231-.127,5.672,5.672,0,0,1-2.141-2.609,3.912,3.912,0,0,0,.742,2.333c.085.106.148.212.233.318a5.923,5.923,0,0,0,1.951,1.611,7.343,7.343,0,0,0,2.4.763,8.642,8.642,0,0,0,2.226,0,9.04,9.04,0,0,0,2.693-.826,8.663,8.663,0,0,1-8.058.233,6.49,6.49,0,0,1-3.711-6.827c.042-.17.064-.318.106-.488.064-.233.17-.466.255-.7a2.315,2.315,0,0,0-.424.488,1.433,1.433,0,0,1-.148.233,5.8,5.8,0,0,0,.445,6.107,8.558,8.558,0,0,0,4.389,3.393,9.8,9.8,0,0,1-3.328-1.8,8.1,8.1,0,0,1-2.715-4.432,6.525,6.525,0,0,1,1.4-5.874,5.463,5.463,0,0,1,2.078-1.463,4.676,4.676,0,0,0-3.71,2.078,7.736,7.736,0,0,0-.467,8.143,8.92,8.92,0,0,1-1.082-5.216,7.484,7.484,0,0,1,3.033-5.407,6.622,6.622,0,0,1,1.611-.869,5.74,5.74,0,0,1,4.2.084,4.881,4.881,0,0,0-4.58-1.06A7.971,7.971,0,0,0,1303.879,1510.769Z" transform="translate(-1288.707 -1486.416)" />
        </svg>
        <svg id='logo-name' xmlns="http://www.w3.org/2000/svg" width="396" height="102" viewBox="0 0 396 102">
          <text id="NUDGE_TECH" data-name="NUDGE TECH" transform="translate(0 84)" fill="#004e91" fontSize="83" fontFamily="Impact"><tspan x="0" y="0">NUDGE</tspan><tspan y="0" xmlSpace="preserve" fill="#86b2d8"> TECH</tspan></text>
        </svg>
      </Link>
      <S.Website className='website-header' href="https://nudgetech.fr/" target="_blank" rel="noopener noreferrer">Site internet</S.Website>
      <S.Content>
        <NavLinks />
      </S.Content>
    </S.Container>
    <S.MobileContainer onClick={toggleMobileNav}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 80C0 71.16 7.164 64 16 64H432C440.8 64 448 71.16 448 80C448 88.84 440.8 96 432 96H16C7.164 96 0 88.84 0 80zM0 240C0 231.2 7.164 224 16 224H432C440.8 224 448 231.2 448 240C448 248.8 440.8 256 432 256H16C7.164 256 0 248.8 0 240zM432 416H16C7.164 416 0 408.8 0 400C0 391.2 7.164 384 16 384H432C440.8 384 448 391.2 448 400C448 408.8 440.8 416 432 416z" /></svg>
      <MobileNavigation />
    </S.MobileContainer>
    <S.MobileBackground active={mobileOpen} onClick={toggleMobileNav} />
  </>
};

export default Navigation;

const S = {}
S.Container = styled.nav`
  display: flex;
  flex-direction: column;
  max-width: 61px;
  width: fit-content;
  background: ${({ theme }) => theme.card};
  height: 100%;
  padding: 25px 0;
  box-sizing: border-box;
  position: relative;
  align-items: center;
  position: fixed;

  // expand svg
  & #expand {
    z-index: 10;
    padding: 5px;
    width: 15.5px;
    height: 15.5px;
    fill: #fff;
    background: ${({ theme }) => theme.linear};
    position: absolute;
    border-radius: 5px;
    right: -12px;
    top: 80px;
    cursor: pointer;
  }
  & > a {
    padding: 0 6px;
  }
  // logo
  & #logo {
    fill: ${({ theme }) => theme.logo};
    width: 50px;
    min-width: 50px;
  }

  & #logo-name {
    width: 120px;
    min-width: 120px;
    height: auto;
  }

  & #logo-link {
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 10px;
  }
  .website-header {
    display: none;
  }
  
  &.active {
    max-width: 350px;

    & #expand {
      transform: rotate(180deg);
    }
    & #logo-name {
      display: block;
    }
    & .footer {
      display: flex;
    }
    .website-header {
      display: block;
    }
  }

  @media(max-width: 1100px) {
    display: none;
  }
`

S.Website = styled.a`
  font-weight: 500;
  font-size: 14px;
  transition: .3s;

  &:hover {
    color: ${({ theme }) => theme.title};
  }
`

S.Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
  height: 100%;
`

S.NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: fit-content;
  padding-left: 10px;
  padding-right: 25px;

  :first-of-type {
    margin-top: 65px;
  }

  &.bottom {
    margin-top: auto;
  }

  @media(max-width: 1100px) {
    gap: 7px;

    :first-of-type {
      margin-top: 0;
    }

    ${({ border }) => border && css`
      border-top: 0.5px solid #7B7B7B;
      padding-top: 10px;
      margin-top: 10px !important;
    `}
  }
`

S.NavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13.5px;

  & > span {
    white-space: nowrap;
  }
  & > svg {
    fill: ${({ theme }) => theme.text};
    width: 23px;
    height: ${({ height }) => height ? `${height}px` : '20px'};
    transition: background .3s;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 9px;
    border-radius: 10px;
  }
  &.active > svg {
    background: ${({ theme }) => theme.linear};
    fill: #fff;
  }

  @media(max-width: 1100px) {
    & > svg {
      width: 22px;
      padding: 9px;
    }
  }
`

S.Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 13.5px;
  padding: 0;
  gap: 10px;
  font-family: 'Poppins';

  & > span {
    white-space: nowrap;
  }
  & > svg {
    padding: 9px;
    fill: ${({ theme }) => theme.text};
    width: 23px;
    height: ${({ height }) => height ? `${height}px` : '20px'};
  }

  @media(max-width: 1100px) {
    & > svg {
      width: 22px;
      padding: 9px;
    }
  }
`

S.MobileContainer = styled.div`
  display: none;
  position: absolute;
  right: 20px;
  top: 20px;

  // menu svg
  & > svg {
    height: 35px;
    width: 35px;
    fill: #fff;
    padding: 1px 8px;
    box-sizing: border-box;
    background: ${({ theme }) => theme.linear};
    border-radius: 5px;
    cursor: pointer;
  }
  
  @media(max-width: 1100px) {
    display: block;
  }
  @media(max-width: 650px) {
    top: 13px;
    right: 13px;
  }
`

S.MobileContent = styled.div`
  transform: scale(0);
  transform-origin: top right;
  position: absolute;
  right: 0;
  background: ${({ theme }) => theme.card};
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 5px;
  transition: .3s;
  padding: 20px;
  box-sizing: border-box;
  z-index: 20;

  * {
    fill: ${({ theme }) => theme.text};
    color: ${({ theme }) => theme.text};
  }

  ${({ active }) => active && css`
    transform: scale(1);
  `}
`

S.MobileBackground = styled.div`
  position: absolute;
  z-index: 10;
  background: #0000004a;
  inset: 0;
  display: ${({ active }) => active ? 'block' : 'none'};

  @media(min-width: 1100px) {
    display: none;
  }
`

S.Footer = styled.div`
  display: none;
  flex-wrap: wrap;
  justify-content: center;
  font-weight: lighter;
  margin-top: 10px;
  width: 150px;
  margin: 0 auto;
  margin-top: 20px;
  
  div {
    display: flex;
    gap: 10px;
  }
  a {
    font-size: 12px;
    transition: .3s;

    &:hover {
      color: ${({ theme }) => theme.title};
    }
  }

  .website {
    display: none;
  }

  @media(max-width: 1100px) {
    margin-top: 15px;
    display: flex;
    width: 100%;

    div {
      display: flex;
      gap: 10px;
    }
    .website {
      display: block;
    }
  }
`